<template>
  <td
    class="edit-cell"
    :class="{'selected-cell': isSelect}"
    @dblclick="editCell(true)"
  >
    <div class="span-wrapper">
      <span
        class="value-span"
        :class="{
          'disabled-cell': column.disabled || com.disabled,
          'description-span': textInput,
          'small-font': smallFont
        }"
        ref="span"
      >
        {{ spanValue }}
      </span>
      <textarea
        v-model="form.value"
        @input="handleInput"
        @blur="handleBlur"
        @focus="handleFocus"
        @keydown="handleKeydown"
        :class="{
          'editing-cell': isEdit
        }"
        :disabled="column.disabled || com.disabled || !editable"
        ref="textarea"
      ></textarea>
      <div v-if="showExpand" class="expand-span" @mouseleave="showExpand = false">
        {{spanValue}}
      </div>
      <img
        src="/images/expand-desc-indicator.png"
        class="icon-expand"
        v-if="showExpandIcon"
        @mouseover="showExpand = true"
      />
    </div>
    <div
      v-if="lastCell && showPricesHours"
      class="component-sum"
      :class="{'duplicate-sum': showPricesPrices}"
    >{{ hoursSum }}h</div>
    <div v-if="lastCell && showPricesPrices" class="component-sum prices-sum">{{ priceSumFormat }}</div>
  </td>
</template>

<script>
import { mapGetters } from 'vuex';
import Helpers from '../../../../util/helper';

export default {
  name: 'TextEditCell',
  data () {
    return {
      isEdit: false,
      isSelect: false,
      form: {
        value: ''
      },
      pastedValues: [],
      isPaste: false,
      focused: false,
      showExpandIcon: false,
      showExpand: false
    };
  },
  props: {
    element: {
      required: true
    },
    column: {
      required: true
    },
    moduleKey: {
      type: Number,
      required: true
    },
    comKey: {
      type: Number,
      required: true
    },
    cellKey: {
      type: Number,
      required: true
    },
    prefix: {
      type: String,
      default: null,
    },
    com: {
      type: Object,
      default: null,
    },
    range: {
      type: String,
      default: 'mid',
    },
    textInput: {
      type: Boolean,
      default: false
    },
    lastCell: {
      type: Boolean,
      default: false
    },
    hoursSum: {
      type: Number,
      default: 0
    },
    priceSum: {
      type: Number,
      default: 0
    },
    minValue: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handlePaste() {},
    handleInput(e) {
      if (this.textInput && this.isEdit) {
        return;
      }
      if (!this.isEdit) {
        if (e.inputType === 'historyUndo' || e.inputType === 'historyRedo') {
          return;
        }
        this.editCell(false)
      }
      // if (!this.textInput) {
        const values = e.target.value
          .split(/\r?\n/g)
          .filter(v => v !== '')
        if (values.length == 1) {
          this.isPaste = false
          if (!this.textInput && !Helpers.isNumber(values[0])) {
            this.form.value = values[0].slice(0, -1)
          }
        } else if (values.length > 1) {
          this.isPaste = true
          this.pastedValues = e.target.value
            .split(/\r?\n/g)
            .map(val => {
              return this.parseValue(val, this.minValue)
          })
          this.form.value = values[0]
          this.pasteBottomCells()
        }
      // }
    },
    handleKeydown(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        if (!this.isEdit) {
          this.changeValue('')
        }
      } else if (e.key === 'Escape') {
        if (this.isEdit) {
          this.changeValue(this.elementValue)
          this.cleanEdit()
        }
      } else if (e.key === 'Enter') {
        e.preventDefault()
        if (this.isEdit) {
          this.changeValue(this.form.value)
          this.cleanEdit()
          this.$store.dispatch('keyDownCell');
        } else {
          this.$refs.textarea.focus()
          this.isEdit = true
          if (this.elementValue) {
            this.form.value = this.elementValue
          }
        }
      }
    },
    handleBlur(e) {},
    handleFocus(e) {
      if (!this.isSelect) {
        this.$store.dispatch('updateSelectedCell', this.cellInf)
      }
    },
    editCell(updateEditing) {
      if (!this.editable) {
        return;
      }
      if (!this.isEdit) {
        this.isSelect = true;
        this.isEdit = true;
        // this.form.value = this.elementValue;
        if (
          !this.textInput &&
          (this.form.value === 0 || this.form.value === '0')
        ) {
          this.form.value = ''
        }
        if (updateEditing) {
          this.$store.dispatch('updateEditingCell', this.cellInf)
        }
      }
    },
    async pasteBottomCells() {
      this.isSelect = false;
      this.isPaste = false;
      this.cleanEdit();
      this.$store.dispatch('pasteGridValues', {
        pricingLevel: (this.prefix === 'meta' && this.cellKey !== 2) ? null : this.range,
        projectid: this.$route.params.projectid,
        moduleKey: this.moduleKey,
        component: this.prefix !='percent' ? this.prefix+'Elements' : 'percentTasks',
        comKey: this.comKey,
        cellKey: this.cellKey,
        pastedValues: this.pastedValues
      })
    },
    removePrefix(value) {
      if (this.prefix === 'fixed') { return value.replace('$', '') }
      if (this.prefix === 'hourly') { return value.replace('h', '') }
      if (this.prefix === 'percent') { return value.replace('%', '')  }
      return value
    },
    parseValue(value, defaultValue) {
      if (this.textInput) {
        return value
      }
      return Helpers.parseInt(value) ? Helpers.parseInt(value) : defaultValue
    },
    changeValue(value) {
      this.$store.dispatch('changeGridValue', {
        pricingLevel: this.range,
        projectid: this.$route.params.projectid,
        key3: this.moduleKey,
        component: this.prefix !='percent' ? this.prefix+'Elements' : 'percentTasks',
        key2: this.comKey,
        key: this.cellKey,
        value: this.parseValue(value, this.minValue)
      })
    },
    cleanEdit(value) {
      this.isEdit = false
      this.form.value = ''
      this.$store.dispatch('updateEditingCell', null)
    }
  },
  computed: {
    ...mapGetters(['selectedCell', 'editingCell', 'currentProjectModules', 'showPricesPrices', 'showPricesHours', 'userRole']),
    priceSumFormat() {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(this.priceSum)
    },
    components() {
      return this.currentProjectModules[this.moduleKey].components
    },
    cellInf() {
      return {
        moduleKey: this.moduleKey,
        comKey: this.comKey,
        cellKey: this.cellKey,
        prefix: this.prefix
      }
    },
    spanValue() {
      if (this.isEdit) {
        return ''
      }
      if (this.prefix === 'fixed') { return this.elementValue ? '$' + this.elementValue : '' }
      if (this.prefix === 'hourly') { return this.elementValue ? this.elementValue + 'h' : '' }
      if (this.prefix === 'percent') {
        if (this.elementValue) {
          return this.elementValue + '%'
        } else {
          return this.column.taskPercentOverride ? '(' + this.column.taskPercentOverride + '%)' : ''
        }
      }
      return this.elementValue
    },
    elementValue() {
      if (this.prefix === 'meta' && this.cellKey !== 2) {
        return this.element
      }
      return this.element.mid
    },
    smallFont() {
      return this.prefix === 'percent' && !this.elementValue
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  watch: {
    selectedCell(data) {
      this.isSelect =
        Object.keys(this.cellInf).every(key => this.cellInf[key] === data[key])
      if (!this.isSelect) {
        if (!this.isPaste && this.isEdit) {
          this.changeValue(this.form.value)
        }
        this.cleanEdit();
      } else {
        this.$refs.textarea.focus()
      }
    },
    spanValue(value) {
      setTimeout(() => {
        const element = this.$refs.span
        this.showExpandIcon = element.offsetWidth < element.scrollWidth
      }, 200);
    }
  },
  created () {
  },
  mounted() {
    const element = this.$refs.span
    this.showExpandIcon = element.offsetWidth < element.scrollWidth
  }
}
</script>

<style scoped lang="scss">
.edit-cell {
  .span-wrapper {
    width: 100%;
    display: flex;
    padding: 5px;
    span {
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: auto;
    }
    textarea {
      width: 100%;
      height: 100%;
      font-family: "GG", sans-serif;
      border: none;
      color: transparent;
      font-size: 16px;
      text-shadow: 0 0 0 #2c3e50;
      background: transparent;
      padding: 10px;
      cursor: default;
      display: block;
      resize:none;
      position: absolute;
      top: 0px;
      left: 0px;
    }
    .description-span {
      text-align: left;
      font-size: 13px;
      width: 100%;
      height: 100%;
    }
    .expand-span {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      word-wrap: break-word;
      background: white;
      background-color: white;
      padding: 5px;
      border-radius: 0 0 5px 5px;
      box-shadow: 0 1px 4px 0 rgba(0,0,0,0.25);
      font-size: 13px;
      z-index: 1;
    }
    .disabled-cell {
      color: rgba(0,0,0,0.2);
    }
  }
  .editing-cell {
    text-align: left;
    color: #2c3e50 !important;
    background: white !important;
  }
}
.selected {
  border: 2px solid #f2397d !important;
}
.component-sum {
  position: absolute;
  width: 100px;
  height: 100%;
  top: 0;
  right: 0px;
  color: #050505;
  font-family: GG;
  font-size: 16px;
  font-weight: 400;
  padding-left: 20px;
  background-color: #fff;
  align-items: center;
  display: flex;
  box-shadow: -7px 0 7px -7px rgba(139,139,139,0.5);
}
.duplicate-sum {
  right: 130px !important;
}
.prices-sum {
  width: 130px !important;
}
.icon-expand {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.small-font {
  font-size: 62%;
}
</style>
